/**
 * Onboarding PostHog contract - product analytics for the user's first steps.
 * Tracks the journey from sign-up to a configured organization and first campaign sharing.
 */

const ONBOARDING_EVENT_NAMES_CONST = [
  'onboarding.profile_created',
  'onboarding.organisation_created',
  'onboarding.trial_acknowledged',
  'onboarding.first_create_clicked',
  'onboarding.first_conversation_created',
  'onboarding.first_share_clicked',
] as const;

export type OnboardingEventName = (typeof ONBOARDING_EVENT_NAMES_CONST)[number];

export const ONBOARDING_EVENT_NAMES: readonly OnboardingEventName[] = ONBOARDING_EVENT_NAMES_CONST;

/**
 * Build base properties for onboarding events.
 */
export function buildOnboardingProps(
  extra?: Record<string, unknown>
): Record<string, unknown> {
  return {
    ...extra,
  };
}
